import useTheme from "../../../../common/hooks/useTheme";

import classes from "./CardWithBarChart.module.css";
import { nutrientsTableType } from "../../../../providers/dataPlatformReportTypes";

type Props = {
  data: nutrientsTableType;
};

const CardWithBarChart = ({ data }: Props) => {
  const theme = useTheme();

  const curValue = Math.round((data.current * 100) / data.target);
  return (
    <div
      className={classes.cardContainer}
      style={{
        borderColor: theme.colors_ds.NEUTRAL_BORDER_WEAK,
        backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
      }}
    >
      <div className={classes.cardDetailsContainer}>
        <div
          className={classes.label}
          style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
        >
          {data.label}
        </div>
        <div
          className={classes.value}
          style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
        >
          {`${curValue > 100 ? 100 : curValue}%`}
        </div>
      </div>
      <div
        className={classes.bar}
        style={{ backgroundColor: theme.colors_ds.NEUTRAL_BORDER_GRAPH }}
      >
        <div
          className={classes.barInner}
          style={{
            width: `${curValue > 100 ? 100 : curValue}%`,
            backgroundColor: theme.colors_ds.PRIMARY_GRAPH_MAIN,
          }}
        />
      </div>
    </div>
  );
};

export default CardWithBarChart;
